// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3X4M_","card":"Cards_card__y4jgQ","infected":"Cards_infected__2kM9e","recovered":"Cards_recovered__27nIT","deaths":"Cards_deaths__OL5PV"};